// Shared Recharts color system for the elite light SaaS look — keep every
// chart on this palette instead of hardcoding hex values per page.
export const CHART_COLORS = {
  indigo: "#1d4ed8",
  emerald: "#059669",
  amber: "#d97706",
  rose: "#e11d48",
  blue: "#2563eb",
  violet: "#7c3aed",
  slate: "#94a3b8",
};

export const CHART_SERIES = [
  CHART_COLORS.indigo,
  CHART_COLORS.emerald,
  CHART_COLORS.amber,
  CHART_COLORS.blue,
  CHART_COLORS.rose,
  CHART_COLORS.violet,
];

// Hoarding occupancy status colors, reused across dashboard/city/analysis charts
export const STATUS_CHART_COLORS = {
  occupied: "#10b981",
  available: "#ef4444",
  maintenance: "#f59e0b",
  reserved: "#f59e0b",
  total: "#cbd5e1",
};

export const CHART_GRID_COLOR = "#eef0f4";
export const CHART_AXIS_COLOR = "#94a3b8";
export const CHART_AXIS_STYLE = { fontSize: 11, fill: CHART_AXIS_COLOR };

export const CHART_TOOLTIP_STYLE = {
  background: "#ffffff",
  border: "1px solid #e7e9ee",
  borderRadius: 10,
  boxShadow: "0 6px 14px -4px rgba(15,23,42,0.10), 0 2px 6px -2px rgba(15,23,42,0.05)",
  fontSize: 12,
  padding: "8px 12px",
};

export const CHART_TOOLTIP_LABEL_STYLE = { color: "#0f172a", fontWeight: 600, marginBottom: 4 };
export const CHART_TOOLTIP_ITEM_STYLE = { color: "#475569" };
